import * as Sentry from '@sentry/react';
import { environment } from 'env/cashier';

import { SentryIgnore } from '@cashier/cashier-common';
import { initEventBus, PostMessageAdapter } from '@cashier/cashier-shared';

import registerServiceWorker from './registerServiceWorker';
import { sentryReleaseId } from './sentry-release-id';

const bootstrap = async () => {
  const isDevMode = process.env.NODE_ENV === 'development';

  /**
   * Initialize EventBus with explicit configuration
   *
   * Adapters must always be explicitly provided - no defaults.
   * Use static factory methods on adapters.
   */
  initEventBus({
    enableLogging: isDevMode,
    adapters: [PostMessageAdapter.factory()],
  });

  if (environment.production && !isDevMode) {
    Sentry.init({
      dsn: environment.sentryKey,
      environment: environment.sentryEnvironment,
      ignoreErrors: SentryIgnore,
      integrations: [
        Sentry.captureConsoleIntegration({ levels: ['error'] }),
        Sentry.browserTracingIntegration(),
      ],
      tracePropagationTargets: [environment.appDomain, 'localhost'],
      release: sentryReleaseId,
      tracesSampleRate: environment.sentryEnvironment === 'staging' ? 1 : 0.25,
    });
  }

  const isE2ETest = typeof (window as any).Cypress !== 'undefined';
  if (environment.production && !isE2ETest && !(window as any).isPrerender) {
    registerServiceWorker();
  }

  /* eslint-disable @typescript-eslint/no-explicit-any */
  (window as any).paymentIqCardEncrypterUrl =
    environment.paymentIqCardEncrypterUrl;
};

export default bootstrap;
